import gql from 'graphql-tag';
import client from '../../client';
import { INVENTORY_FIELDS } from '../fragments/inventoryFields';
import { ORDER_FIELDS } from '../fragments/ordersFields';
import { PRODUCT_FIELDS } from '../fragments/productFields';
export const REDEEM_VIP_COUPON = gql `
  ${ORDER_FIELDS}
  ${INVENTORY_FIELDS}
  ${PRODUCT_FIELDS}

  mutation redeemVipCoupon($input: RedeemInput) {
    redeemVipCoupon(input: $input) @rest(type: "RedeemVipCoupon", path: "admin/orders/redeem-vip", method: "POST") {
      data {
        id
      }
    }
  }
`;
export const redeemVipCoupon = (userId, code, isLifetimeVip) => {
    return client.mutate({
        mutation: REDEEM_VIP_COUPON,
        variables: {
            input: {
                data: {
                    userId,
                    code,
                    isLifetimeVip,
                },
            },
        },
    });
};
export default redeemVipCoupon;
